<template>
  <div class="wrap">
    <div v-for="(item, index) in list"
         :key="index">
      <van-swipe-cell>
        <div :class="diffTime(item.endTime) ? 'card_no_use' : 'can_use_card'">
          <div class="card_left"
               :class="{ used_color_one: diffTime(item.endTime) }">
            <div class="card_money">
              <span>￥</span>
              <span>{{ parseFloat(item.price) }}</span>
            </div>
            <div class="card_use">
              {{ item.customizeName.split('-')[1] }}
            </div>
          </div>
          <div class="card_mid">
            <p class="card_mid_fir"
               :class="{ used_color_two: diffTime(item.endTime) }">
              {{ item.customizeName.split('-')[0] }}
            </p>
            <p class="card_mid_sec"
               :class="{ used_color_three: diffTime(item.endTime) }">
              有效期至{{ changeTime(item.endTime) }}
            </p>
          </div>
          <div class="card_right"
               v-if="!diffTime(item.endTime)"
               @click="toProductDetail(item.goldCommodityId,item.id)">
            立即使用
          </div>
          <img v-else
               src="@/assets/img/vipActive/show_card_used.png"
               alt=""
               class="show_used_img" />
        </div>
      </van-swipe-cell>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data () {
    return {
      showToast: false,
      list: [],
      nowTime: moment()
        .locale("zh-cn")
        .format("YYYY-MM-DD HH:mm:ss"),
      id: ''
    };
  },
  mounted () {
    this.id = this.$route.query.id;
    this.util.title("我的卡券");
    this.getList();
  },
  methods: {
    getList () {
      this.$get("/app/valueAdded/new/gifts/" + this.id).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.list = res.data;
          console.log(this.list);
        }
      });
    },
    toProductDetail (id, goldId) {
      //前往卡券详情
      this.$router.push({
        path: "/vipActive/couponDetail",
        query: { id: id, goldId: goldId },
      });
    },
    diffTime (time) {
      let txt = time.split(" ");
      let getTime = txt[0] + " " + txt[1];
      let passTime =
        moment(this.nowTime).diff(moment(getTime), "seconds") > 0
          ? true
          : false;
      return passTime;
      //true:过期；false:未过期
    },
    changeTime (time) {
      let txt = time.split(" ");
      return txt[0];
    },
  },
}
</script>

<style scoped>
.wrap {
  padding: 0.15rem;
  background: #f6f7f8;
}
.can_use_card {
  width: 100%;
  height: 1rem;
  background: url('../../assets/img/vipActive/card_can_use.png') no-repeat
    center center;
  background-size: 100% 100%;
  margin-bottom: 0.1rem;
  position: relative;
}
.card_no_use {
  width: 100%;
  height: 1rem;
  background: url('../../assets/img/vipActive/card_no_use.png') no-repeat center
    center;
  background-size: 100% 100%;
  margin-bottom: 0.1rem;
  position: relative;
}
.card_left {
  color: #2f2f2f;
  position: absolute;
  /* left: 0.2rem;
  top: 0.05rem; */
  left: 6%;
  top: 5%;
}
.card_money span:first-child {
  font-size: 0.24rem;
}
.card_money span:last-child {
  font-weight: bold;
  font-size: 0.4rem;
}
.card_use {
  font-size: 0.12rem;
}
.card_mid {
  position: absolute;
  /* left: 1.13rem;
  top: 0.15rem; */
  left: 33%;
  top: 15%;
}
.card_mid_fir {
  color: #2f2f2f;
  font-weight: bold;
  font-size: 0.16rem;
}
.card_mid_sec {
  color: #aaaaaa;
  font-size: 0.14rem;
  margin-top: 0.18rem;
}
.card_right {
  width: 0.12rem;
  margin-left: 0.2rem;
  font-size: 0.12rem;
  color: #ff880d;
  font-weight: bold;
  position: absolute;
  /* right: 0.14rem;
  top: 0.15rem; */
  right: 4%;
  top: 15%;
}
.used_color_one {
  color: #ffffff;
}
.used_color_two {
  color: #aaaaaa;
}
.used_color_three {
  color: #d1d1d1;
}
.show_used_img {
  width: 0.6rem;
  height: 0.6rem;
  position: absolute;
  right: 0.15rem;
  bottom: 0.2rem;
}
.show_del {
  width: 0.14rem;
  height: 0.14rem;
  position: absolute;
  right: 0.13rem;
  top: 0.13rem;
}
.delete-button {
  height: 100%;
}
>>> .van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.sure_box {
  width: 2.65rem;
  height: 1.57rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.1rem;
}
.suer_txt {
  color: #2f2f2f;
  font-size: 0.15rem;
  font-weight: bold;
  padding: 0.25rem 0.3rem;
  line-height: 0.7rem;
  text-align: center;
  height: 1.1rem;
}
.sure_money {
  color: #ff514a;
}
.sure_bot {
  border-top: 0.01rem solid #f0f0f0;
  height: 0.46rem;
  font-size: 0.15rem;
  font-weight: bold;
  display: flex;
}
.sure_btn_left {
  color: #2f2f2f;
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 0.01rem solid #f0f0f0;
}
.sure_btn_right {
  color: #ff880d;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>